import React from 'react';

var AccordionItemRenderContext = React.createContext(null);

export { AccordionItemRenderContext };
